import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Ingresá el nombre exacto del fabricante tal como figura en los manuales.',
    'Las marcas de equipos y las marcas de repuestos son catálogos separados.',
    'No dupliques marcas con variaciones de nombre: "Caterpillar" y "CAT" deberían ser una sola.',
  ],
  nextSteps: [
    'Crear los Modelos asociados a cada marca.',
    'Al dar de alta equipos, podrás asignarles marca y modelo.',
  ],
};

const ConfiguracionMarcas = () => (
  <ConfiguracionBase
    apiEndpoint="marcas"
    titulo="Marcas"
    descripcion="Gestión de marcas de equipos y vehículos"
    icon="fas fa-tags"
    compact
    help={HELP}
  />
);

export default ConfiguracionMarcas;
